import agendaMedicaService from "../services/agendaMedica";

const agendaMedicaMixin = {
    data() {
        return {
            agenda: [
                // { editar: 'Item', bloco: 'Item', hora: '14:05', paciente: 'Paciente', tipoAtendimento: 'Tipo Atendimento', comprovante: 'Comprovante', unidade: 'Unidade', plano: 'Plano'},
                // { editar: 'Item', bloco: 'Item', hora: '14:05', paciente: 'Paciente', tipoAtendimento: 'Tipo Atendimento', comprovante: 'Comprovante', unidade: 'Unidade', plano: 'Plano'},
            ],
            agendaMedicaFields: [
                {
                    key: 'editar',
                    label: 'Editar',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'bloco',
                    label: 'Bloco',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'horario',
                    label: 'Hora',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'cliente',
                    label: 'Paciente',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'procedimento',
                    label: 'Procedimento',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'status',
                    label: 'Status',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'local',
                    label: 'Local',
                    class: 'size-col-20',
                    field: '',
                },
                {
                    key: 'status_atendimento',
                    label: 'Status Atendimento',
                    class: 'size-col-20',
                    field: '',
                },
            ]
        }
    },
    methods: {
        loadAgendaMedica(conveniado=null, local=null, data=null, page=null, status=null) {
            return agendaMedicaService.list(conveniado, local, data, page, status).then(response => response.data)
        },
        async findById(id, hideConveniado=null){
            console.log(hideConveniado)
            return await agendaMedicaService.findById(id, hideConveniado)
        },
        async registerAgendaMedica(agendaMedica) {
            return await agendaMedicaService.create(agendaMedica)
        },
        async registerManyAgendaMedica(agendasMedica) {
            return await agendaMedicaService.createMany(agendasMedica)
        },
        async editAgendaMedica(id, agendaMedica) {
            return await agendaMedicaService.update(id, agendaMedica)
        },
        async confirmAgendaMedica(agendaMedica) {
            return await agendaMedicaService.confirmar(agendaMedica)
        },
        async deleteAgendaMedica(id) {
            return await agendaMedicaService.remove(id)
        },
        async findLimitPerDay(limit){
            return await agendaMedicaService.findLimitPerDay(limit)
        },
        async findDaysWitScheduling(conveniadoId, status=null){
            return await agendaMedicaService.findDaysWitScheduling(conveniadoId, status)
        },
        async changeByDate(changeOptions){
            return await agendaMedicaService.changeByDate(changeOptions)
        },
        async updateStatusService(id, statusAtendimento) {
            return await agendaMedicaService.updateStatusService(id, statusAtendimento)
        },
    }
}

export default agendaMedicaMixin;